import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { DialogTableDataRow } from '../../../content/interfaces/dialog-table-data-row';
import { I18nService } from '../../../core/services/i18n.service';
import { SpsMaskedPasswordComponent } from '../sps-masked-password/sps-masked-password.component';
import { SpsPaymentStatusTagComponent } from '../sps-payment-status-tag/sps-payment-status-tag.component';

@Component({
  selector: 'sps-payment-method-data-card',
  imports: [
    Card,
    Button,
    PrimeTemplate,
    TableModule,
    NgClass,
    SpsPaymentStatusTagComponent,
    SpsMaskedPasswordComponent
  ],
  templateUrl: './payment-method-data-card.component.html'
})
export class PaymentMethodDataCardComponent {

  @Input() title: string;
  @Input() editable: boolean = false
  @Input() tableData: DialogTableDataRow[] = [];

  @Input() titleColumnWidth: string = 'auto';
  @Input() valueColumnWidth: string = 'auto';

  @Output() onEdit = new EventEmitter<true>();

  /**
   * Password is hidden by default
   */
  showPassword: boolean = false;

  constructor(public i18n: I18nService) {

  }


}
